

// firebase.js
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/auth';
import 'firebase/compat/app-check'; // App Check モジュールをインポート

const firebaseConfig = {
  apiKey: "AIzaSyDVRU8ug2u6QnC7LHkTAjAw3roVqNapC-A",
  authDomain: "pethospital-website.firebaseapp.com",
  projectId: "pethospital-website",
  storageBucket: "pethospital-website.appspot.com",
  messagingSenderId: "660089280232",
  appId: "1:660089280232:web:268da106016d81a3681b5d",
  measurementId: "G-X2E11ZSBVE"
};

// Firebase アプリを初期化
firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const storage = firebase.storage();
const auth = firebase.auth();

// App Check の設定
const appCheck = firebase.appCheck();
appCheck.activate(
  '6Lefv30qAAAAAJCPyiCQZSW_S9JVSPHtV58V9BOJ',  // Firebase Consoleで取得したreCAPTCHAサイトキー
  true // 本番環境では false に設定することで App Check を強制します
);

export { db, storage, auth };
